import { useSetHeaderTitle } from 'shared/hooks/useSetHeader';
import { RepresentativesContainer } from './Representatives.styles';
import { RepresentativesProvider } from './context/RepresentativesProvider';
import { RepresentativesModalProvider } from './context/RepresentativesModalProvider';
import RepresentativesList from './features/RepresentativesList/RepresentativesList';
import AddRepresentatives from './features/AddRepresentatives/AddRepresentatives';

const Representatives = () => {
  useSetHeaderTitle('Representatives');

  return (
    <RepresentativesProvider>
      <RepresentativesModalProvider>
        <RepresentativesContainer>
          <RepresentativesList />
          <AddRepresentatives />
        </RepresentativesContainer>
      </RepresentativesModalProvider>
    </RepresentativesProvider>
  );
};

export default Representatives;
